import { render } from "./StockTake.vue?vue&type=template&id=32a3cdde&scoped=true"
import script from "./StockTake.vue?vue&type=script&lang=js"
export * from "./StockTake.vue?vue&type=script&lang=js"

import "./StockTake.vue?vue&type=style&index=0&id=32a3cdde&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a3cdde"]])

export default __exports__